import { Component, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UserService } from '../auth/service/user.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit{

  userData:any;
  collapsed = true;
  constructor(private renderer: Renderer2, private userService:UserService, private router:Router) {

    router.events.subscribe((val) => {
      // see also 
      if(val instanceof NavigationEnd) {
        if(val.url!='/home'){
          this.renderer.removeClass(document.body, 'has-stick-nav');
        }
      }
  });
  }


  ngOnInit(): void {
    this.userService.userData.subscribe((userData:any)=>{
      this.userData = userData;
    });
    
  }

  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= 100) {
      this.sticky = true;
      this.renderer.addClass(document.body, 'has-stick-nav');
    } else {
      this.sticky = false;
      this.renderer.removeClass(document.body, 'has-stick-nav');
    }
  }
  sticky = false;
}
